/** Default cover SVG markup — keep in sync with `client/public/assets/*.svg` */

export const PROFILE_COVER_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 320" preserveAspectRatio="xMidYMid slice" role="img" aria-label="Default profile cover">
  <defs>
    <linearGradient id="profile-bg" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stop-color="#3a2418"/>
      <stop offset="48%" stop-color="#333333"/>
      <stop offset="100%" stop-color="#241a14"/>
    </linearGradient>
    <radialGradient id="profile-glow" cx="78%" cy="22%" r="50%">
      <stop offset="0%" stop-color="#f26522" stop-opacity="0.32"/>
      <stop offset="100%" stop-color="#f26522" stop-opacity="0"/>
    </radialGradient>
  </defs>
  <rect width="1200" height="320" fill="url(#profile-bg)"/>
  <rect width="1200" height="320" fill="url(#profile-glow)"/>
  <g opacity="0.14" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round">
    <line x1="72" y1="228" x2="420" y2="228"/>
    <line x1="72" y1="256" x2="360" y2="256"/>
    <line x1="72" y1="284" x2="280" y2="284"/>
  </g>
  <g fill="none" stroke-linecap="round" stroke-linejoin="round">
    <path d="M930 58c18 8 34 22 44 40" stroke="#f5a623" stroke-width="2.5" stroke-opacity="0.45"/>
    <path d="M872 92c28-6 56-2 78 14 8 6 14 14 18 23" stroke="#f26522" stroke-width="2.5" stroke-opacity="0.5"/>
    <path d="M848 148c10-18 26-32 46-40 8-3 16-5 24-5" stroke="#ffffff" stroke-width="2" stroke-opacity="0.22"/>
    <path d="M900 176c-8 14-22 26-38 32-6 2-12 3-18 3" stroke="#f26522" stroke-width="3" stroke-opacity="0.55"/>
    <ellipse cx="952" cy="214" rx="22" ry="8" stroke="#f26522" stroke-width="2" stroke-opacity="0.35"/>
    <path d="M938 214h28" stroke="#f26522" stroke-width="2" stroke-opacity="0.35"/>
  </g>
  <circle cx="1040" cy="78" r="5" fill="#f26522" fill-opacity="0.35"/>
  <circle cx="1068" cy="108" r="3" fill="#ffffff" fill-opacity="0.18"/>
</svg>`;

export const GROUP_COVER_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 320" preserveAspectRatio="xMidYMid slice" role="img" aria-label="Default group cover">
  <defs>
    <linearGradient id="group-bg" x1="0%" y1="100%" x2="100%" y2="0%">
      <stop offset="0%" stop-color="#2a2118"/>
      <stop offset="45%" stop-color="#333333"/>
      <stop offset="100%" stop-color="#3a2418"/>
    </linearGradient>
    <radialGradient id="group-glow" cx="28%" cy="38%" r="55%">
      <stop offset="0%" stop-color="#f26522" stop-opacity="0.26"/>
      <stop offset="100%" stop-color="#f26522" stop-opacity="0"/>
    </radialGradient>
  </defs>
  <rect width="1200" height="320" fill="url(#group-bg)"/>
  <rect width="1200" height="320" fill="url(#group-glow)"/>
  <g opacity="0.12" stroke="#ffffff" stroke-width="2" stroke-linecap="round">
    <path d="M760 92c48-18 104-12 142 18"/>
    <path d="M748 248c56 22 128 18 176-12"/>
  </g>
  <g fill="#ffffff" fill-opacity="0.16">
    <circle cx="860" cy="118" r="28"/>
    <circle cx="930" cy="98" r="24"/>
    <circle cx="1000" cy="118" r="28"/>
  </g>
  <g fill="none" stroke="#f26522" stroke-width="2.5" stroke-opacity="0.42">
    <circle cx="860" cy="118" r="28"/>
    <circle cx="930" cy="98" r="24"/>
    <circle cx="1000" cy="118" r="28"/>
  </g>
  <g stroke="#f5a623" stroke-width="2" stroke-opacity="0.35" stroke-linecap="round">
    <line x1="886" y1="112" x2="906" y2="104"/>
    <line x1="954" y1="104" x2="974" y2="112"/>
  </g>
  <g fill="none" stroke="#ffffff" stroke-opacity="0.12" stroke-width="2">
    <path d="M120 220h220"/>
    <path d="M120 248h180"/>
    <path d="M120 276h140"/>
  </g>
  <circle cx="1080" cy="64" r="4" fill="#f26522" fill-opacity="0.4"/>
</svg>`;

export function svgToDataUrl(svg) {
  return `data:image/svg+xml,${encodeURIComponent(svg.trim())}`;
}

export const DEFAULT_PROFILE_COVER_DATA_URL = svgToDataUrl(PROFILE_COVER_SVG);
export const DEFAULT_GROUP_COVER_DATA_URL = svgToDataUrl(GROUP_COVER_SVG);
